import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { i18n } = useTranslation('language_list');
  const languagesList = i18n.store.data[i18n.language].language_list;
  const serviceLangsOptions = useMemo(() => Object.keys(languagesList).map((key) => ({ value: key, label: languagesList[key] })), [i18n.language]);
  return { data: serviceLangsOptions };
};
